const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type BehaviorEvaluationPeriod = 'first_half' | 'second_half';

export type BehaviorEvaluationItem = {
  behaviorItemId: number;
  score: number;
  comment: string;
};

export type BehaviorEvaluationSheet = {
  overallComment: string;
  rolePoint: number;
  items: BehaviorEvaluationItem[];
};

export type BehaviorEvaluationOverviewResponse = {
  supervisorUserId: string | null;
  selfEvaluation: BehaviorEvaluationSheet;
  supervisorEvaluation: BehaviorEvaluationSheet;
};

export type BehaviorEvaluationByTargetResponse = {
  evaluatorEvaluation: BehaviorEvaluationSheet;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message = typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchBehaviorEvaluationOverview(input: {
  userId: string;
  termNo: number;
  period: BehaviorEvaluationPeriod;
}) {
  const params = new URLSearchParams({
    userId: input.userId,
    termNo: String(input.termNo),
    period: input.period,
  });
  const response = await fetch(`${apiBaseUrl}/api/behavior-evaluations/overview?${params}`);
  await throwIfNotOk(response);
  return (await response.json()) as BehaviorEvaluationOverviewResponse;
}

export async function fetchBehaviorEvaluationByTarget(input: {
  evaluatorUserId: string;
  targetUserId: string;
  termNo: number;
  period: BehaviorEvaluationPeriod;
}) {
  const params = new URLSearchParams({
    evaluatorUserId: input.evaluatorUserId,
    targetUserId: input.targetUserId,
    termNo: String(input.termNo),
    period: input.period,
  });
  const response = await fetch(`${apiBaseUrl}/api/behavior-evaluations/by-target?${params}`);
  await throwIfNotOk(response);
  return (await response.json()) as BehaviorEvaluationByTargetResponse;
}

export async function saveSelfBehaviorEvaluation(input: {
  userId: string;
  termNo: number;
  period: BehaviorEvaluationPeriod;
  items: BehaviorEvaluationItem[];
}) {
  const response = await fetch(`${apiBaseUrl}/api/behavior-evaluations/self`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}

export async function saveEvaluatorBehaviorEvaluation(input: {
  evaluatorUserId: string;
  targetUserId: string;
  termNo: number;
  period: BehaviorEvaluationPeriod;
  overallComment: string;
  rolePoint: number;
  items: BehaviorEvaluationItem[];
}) {
  const response = await fetch(`${apiBaseUrl}/api/behavior-evaluations/evaluator`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}
